import { jsx as t, jsxs as p } from "react/jsx-runtime";
import "react";
import { Box as s, Stack as c } from "@mui/material";
import { faCheck as n } from "@fortawesome/pro-regular-svg-icons";
import { s as e } from "./spacings-C27fg6SF.js";
import { C as l, I as d } from "./DropdownMultipleSearch-DCJiQ_eP.js";
import "@fortawesome/fontawesome-svg-core";
import "@mui/material/Box";
import "@mui/material/Checkbox";
import "@fortawesome/pro-solid-svg-icons";
import "@fortawesome/pro-light-svg-icons";
import "@mui/material/Stack";
import "@mui/material/Link";
import "@mui/material/Typography";
import "@mui/material/Tooltip";
import "@mui/material/Fade";
import "@mui/material/Button";
import "@mui/material/styles";
import "@mui/material/CssBaseline";
import "@mui/material/useAutocomplete";
import "@fortawesome/react-fontawesome";
import "@fortawesome/pro-regular-svg-icons/faXmark";
import "@emotion/cache";
import "@emotion/react";
import "@fortawesome/pro-solid-svg-icons/faCircle";
import "@mui/material/Chip";
import "@mui/material/Avatar";
import "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import "@mui/material/ButtonGroup";
import "@mui/material/Switch";
import "@mui/material/Radio";
import "@mui/material/FormLabel";
import "@mui/material/Autocomplete";
import "@mui/material/FormHelperText";
import "@mui/material/FormControl";
import "@mui/material/OutlinedInput";
import "@mui/material/Input";
import "@mui/material/InputAdornment";
import "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import "@fortawesome/pro-solid-svg-icons/faCheck";
import "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import "@react-spring/web";
import "./ContentPanel-DRC79oum.js";
import "react-dropzone";
import "@vidstack/react";
import "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import "@vidstack/react/icons";
import "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import "@fortawesome/pro-solid-svg-icons/faArrowRight";
import "@mui/material/Popper";
import "@fortawesome/pro-regular-svg-icons/faLinkSimple";
import "copy-text-to-clipboard";
import "@fortawesome/pro-solid-svg-icons/faExpandWide";
import "@fortawesome/pro-solid-svg-icons/faCompressWide";
import "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import "@fortawesome/pro-solid-svg-icons/faToggleOff";
import "@fortawesome/pro-solid-svg-icons/faEye";
import "react-use";
import "color";
import "react-rnd";
import "react-hotkeys-hook";
import "./AutoScrollContainer-CzyjIY1o.js";
import "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
import { T as f } from "./Typography-HkIo7ajX.js";
const o = 20, h = ({ option: i, isSelected: r }) => {
  if (i.hasCheckbox) {
    const m = r ? i.isIndeterminate : !1;
    return /* @__PURE__ */ t(
      l,
      {
        checked: r,
        size: "small",
        disabled: i.isDisabled,
        indeterminate: m
      }
    );
  }
  return i.icon ? typeof i.icon == "string" ? /* @__PURE__ */ t(
    "img",
    {
      width: o,
      src: i.icon,
      alt: "icon",
      style: { objectFit: "cover" }
    }
  ) : /* @__PURE__ */ t(
    s,
    {
      flexBasis: o,
      height: o,
      display: "flex",
      alignItems: "center",
      children: i.icon
    }
  ) : null;
}, x = ({ option: i, isSmallSize: r = !1 }) => i.LabelComponent ?? /* @__PURE__ */ t(
  f,
  {
    fontWeight: "medium",
    variant: "text",
    size: r ? "sm" : "md",
    children: i.label
  }
), g = "selected-icon", Oi = ({ option: i, isSelected: r, isSmallSize: m = !1, ...a }) => /* @__PURE__ */ p(
  "li",
  {
    ...a,
    ...i.isHidden && { style: { display: "none" } },
    children: [
      /* @__PURE__ */ p(
        c,
        {
          display: "flex",
          alignItems: "center",
          direction: "row",
          width: "100%",
          mr: e.md,
          spacing: e.md,
          children: [
            /* @__PURE__ */ t(
              h,
              {
                option: i,
                isSelected: r
              }
            ),
            /* @__PURE__ */ t(
              x,
              {
                option: i,
                isSmallSize: m
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ t(
        s,
        {
          className: g,
          display: "flex",
          width: 20,
          alignItems: "center",
          children: !!r && !i.hasCheckbox && /* @__PURE__ */ t(d, { icon: n })
        }
      )
    ]
  }
);
export {
  Oi as S,
  o as i,
  g as s
};
